import SearchPage from "./SearchPage";

export { SearchPage };
export default SearchPage;
